import React from "react";
// import Navbar from "../Components/Navbar/Navbar";
// import Footer from "../Components/Footer/Footer";
import { Outlet } from "react-router-dom";
// import ScrollTop from "../Components/ScrollTop/ScrollTop";
const MainLayout = () => {
  return (
    <>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default MainLayout;
